const DEFAULT_IOS_APP_URL = 'https://apps.apple.com/app/id6801179310';
const DEFAULT_ANDROID_APP_URL =
  'https://play.google.com/store/apps/details?id=com.bellyfat.app';

export const site = {
  iosAppUrl:
    (import.meta.env.VITE_IOS_APP_URL as string | undefined)?.trim() ||
    DEFAULT_IOS_APP_URL,
  androidAppUrl:
    (import.meta.env.VITE_ANDROID_APP_URL as string | undefined)?.trim() ||
    DEFAULT_ANDROID_APP_URL,
  supportEmail:
    (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined)?.trim() ||
    'omnivatissynergy@gmail.com',
  privacyUrl: '/privacy',
  termsUrl: '/terms',
  supportUrl: '/support',
  /** Brand mark (files/logos/logo512.svg). */
  logoUrl: '/logo512.svg',
  /** Raster mark for dark surfaces / OG. */
  logoOnDarkUrl: '/logo512.png',
};

export type SiteConfig = typeof site;
